

const chartStyle = {
    height: 500,
    width: '100%'
}
export  {chartStyle}